import { render, staticRenderFns } from "./OtpCode.vue?vue&type=template&id=6cd2a1a0&scoped=true&"
import script from "./OtpCode.vue?vue&type=script&lang=js&"
export * from "./OtpCode.vue?vue&type=script&lang=js&"
import style0 from "./OtpCode.vue?vue&type=style&index=0&id=6cd2a1a0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd2a1a0",
  null
  
)

export default component.exports